export default {
  root: {
    fontSize: 12
  },
  contained: {
    marginLeft: 8
  }
};
